"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const common_buoy_input_1 = require("@buoyhealth/common.buoy-input");
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const BUTTON_SIZE = 48;
const BUTTON_HORIZ_MARGIN = 6;
const ButtonWrapper = styled_components_1.default.div `
  margin: 32px auto 16px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    margin-top: 0;
    max-width: ${({ $maxWidth }) => `${$maxWidth}px`};
  }
`;
const StyledToggleButton = (0, styled_components_1.default)(ToggleButton_1.default) `
  &.MuiToggleButton-root {
    padding: 5px 15px;
    margin: ${`8px ${BUTTON_HORIZ_MARGIN / 2}px`};
    min-width: ${`${BUTTON_SIZE}px`};
    min-height: ${`${BUTTON_SIZE}px`};
    border-color: ${({ theme }) => theme.palette.gray[60]};

    @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
      margin: 8px;
    }

    &.Mui-selected {
      background-color: ${({ theme }) => theme.palette.primary.main};
      border-color: ${({ theme }) => theme.palette.primary.main};

      .MuiToggleButton-label {
        color: ${({ theme }) => theme.palette.common.white};
      }

      &:hover {
        background-color: ${({ theme }) => theme.palette.primary.main};
      }
    }
  }

  .MuiToggleButton-label {
    color: ${({ theme }) => theme.palette.primary.main};
    font-size: 18px;
    pointer-events: none;
  }
`;
const RadioWrapper = styled_components_1.default.div `
  padding-bottom: 16px;
  display: flex;
  justify-content: center;
`;
const LabelWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
`;
const ScaleKeyLabel = styled_components_1.default.span `
  ${({ theme }) => theme.typography.variants.primary.small};
  color: ${({ theme }) => theme.palette.gray[60]};

  &:last-of-type {
    text-align: right;
  }
`;
const NumericScale = ({ isMobile, onChange, scale, value, }) => {
    const options = (0, react_1.useMemo)(() => {
        const result = [];
        for (let i = scale.min.value; i <= scale.max.value; i++) {
            result.push({ label: i.toString(), value: i.toString() });
        }
        return result;
    }, [scale]);
    const handleChange = (event) => {
        onChange(event.target.value);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isMobile ? ((0, jsx_runtime_1.jsx)(ButtonWrapper, { "$maxWidth": (options.length * (BUTTON_SIZE + BUTTON_HORIZ_MARGIN)) / 2 +
                    BUTTON_SIZE, "data-testid": "button-numeric-scale", children: options.map((option) => ((0, jsx_runtime_1.jsx)(StyledToggleButton, { "data-testid": `numeric-scale-button-${option.value}`, onChange: handleChange, selected: option.value === value, value: option.value, children: option.label }, option.value))) })) : ((0, jsx_runtime_1.jsx)(RadioWrapper, { "data-testid": "radio-numeric-scale", children: (0, jsx_runtime_1.jsx)(common_buoy_input_1.RadioGroup, { labelPlacement: "bottom", onChange: handleChange, options: options, row: true }) })), (0, jsx_runtime_1.jsxs)(LabelWrapper, { children: [(0, jsx_runtime_1.jsxs)(ScaleKeyLabel, { children: [scale.min.value, " - ", scale.min.label] }), (0, jsx_runtime_1.jsxs)(ScaleKeyLabel, { children: [scale.max.value, " - ", scale.max.label] })] })] }));
};
exports.default = NumericScale;
//# sourceMappingURL=index.js.map